import MuiDrawer from '@mui/material/Drawer';
import {
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithChildren,
  PropsWithoutRef,
  RefAttributes,
} from 'react';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;

export type DrawerPosition = 'left' | 'right' | 'top' | 'bottom';

export type Props = {
  open: boolean;
  onClose: () => void;
  position?: DrawerPosition;
  tid?: string;
  paperTid?: string;
} & PropsWithChildren;

export const Drawer: FR<HTMLDivElement, Props> = forwardRef((props: Props, ref) => {
  const { open, onClose, position = 'right', children, tid, paperTid } = props;

  return (
    <MuiDrawer
      ref={ref}
      anchor={position}
      open={open}
      onClose={onClose}
      data-testid={tid}
      ModalProps={{
        keepMounted: true,
      }}
      PaperProps={{
        'data-testid': paperTid,
        sx: {
          backgroundColor: '#ffffff',
          p: 2,
        },
      }}
    >
      {children}
    </MuiDrawer>
  );
});
